// Preview an image to be uploaded in the given element
export default function (input, element) {
  if (input.files && input.files[0]) {
    const reader = new FileReader();
    reader.onload = (e) => $(element).attr('src', e.target.result);

    reader.readAsDataURL(input.files[0]);
  }
}
